export const TABLE_HEAD_CELL_TEMPLATE_PREFIX = "head-";
export const TABLE_HEAD_CELL_TEMPLATE = "head-cell";
export const TABLE_DATA_CELL_TEMPLATE = "data-cell";

export const ROW_EXPANSION = "row-expansion";
